export default {
  pipefishUsers: [],
  clients: [],
  projects: [],
  activities: [],
  practices: [],
  statements: [],
  summary: [],
  selectedDates: null,
  approvalObject: {},
}